import { InjectionToken } from '@angular/core';
import { I18nOptimoveDescLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const I18N_OPTIMOVE_DESC_LOADER: InjectionToken<I18nOptimoveDescLoader<Record<string, string>>> =
  new InjectionToken<I18nOptimoveDescLoader<Record<string, string>>>('i18nOptimoveDescLoader', {
    factory: () => () => Promise.resolve({})
  });
